
<app-page-header-with-button
  title="Itens de Orçamento"
  icon="fas fa-list"
  subtitle="Gerencie os itens de orçamento do sistema"
  buttonText="Novo Item"
  buttonIcon="fas fa-plus"
  (buttonClick)="novoItem()">
</app-page-header-with-button>

<!-- Filtros -->
<form [formGroup]="filtrarGrupoForm" (ngSubmit)="onSubmit()" class="mb-3">
  <div class="card col-12 mb-4">
    <div class="card-body">
      <div class="row">
        <div class="col-md-9">
          <p class="card-title-desc">Utilize o filtro para consultar os itens selecionando o grupo
            pertencente
          </p>
          <div style="align-items:center" class="col-12 d-flex ">
            <div class="col-md-6 col-sm-6 mb-3 form-group ">
              <label class="form-label" for="nome">Grupos</label>

              <select class="form-select form-select-sm" id="nome" formControlName="nome">
                <option *ngFor="let group of groups" [value]="group.id">
                  {{ group.nome }}
                </option>
              </select>
            </div>

            <div style="margin-left: 13px;" class="pt-2 col-sm-6 col-md-6 form-group">
              <button class="btn btn-primary" type="submit">
                @if(budgetService.loading) {
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Carregando
                } @else {
                Filtrar
                }
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- Lista -->
<div [formGroup]="filtrarNomeForm" class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5 class="card-title mb-0">
      <i class="fas fa-list me-2"></i>
      Itens de Orçamento
      <ng-container *ngIf="groupItems$ | async as grupoItemResponse">
        <ng-container *ngIf="grupoItemResponse?.paginacao?.totalDeItens">
          ({{ grupoItemResponse.paginacao.totalDeItens }})
        </ng-container>
      </ng-container>
    </h5>
  </div>
  <div class="card-body p-0">
    <div *ngIf="budgetService.loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <p class="mt-2 text-muted">Carregando itens...</p>
    </div>
    
    <ng-container *ngIf="!budgetService.loading">
      <ng-container *ngIf="groupItems$ | async as grupoItemResponse">
        <div *ngIf="grupoItemResponse?.grupoItem?.itens && (grupoItemResponse.grupoItem?.itens?.length ?? 0) > 0" class="table-responsive">
          <table class="table table-hover table-striped mb-0">
            <thead class="table-light">
              <tr>
                <th class="px-3 py-2">
                  <div class="d-flex flex-column">
                    <span class="fw-bold mb-2">Nome Item</span>
                    <input formControlName="nome" name="nome" type="text" class="form-control form-control-sm"
                      placeholder="Filtrar" />
                  </div>
                </th>
                <th class="px-3 py-2">
                  <span class="fw-bold">Valor</span>
                </th>
                <th class="px-3 py-2">
                  <span class="fw-bold">M²/M² Adicional</span>
                </th>
                <th class="px-3 py-2 text-center">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of grupoItemResponse.grupoItem?.itens">
                <td class="px-3 py-2">{{ item?.nome }}</td>
                <td class="px-3 py-2">{{ item?.valor }}</td>
                <td class="px-3 py-2">{{ formatarMetrosQuadrados(item) }}</td>
                <td class="px-3 py-2 text-center">
                  <div class="btn-group btn-group-sm" role="group">
                    <button
                      type="button"
                      class="btn btn-outline-primary me-1"
                      title="Editar"
                      (click)="openModalEditar(grupoItemResponse?.grupoItem?.id, item, grupoItemResponse?.grupoItem?.tipoDeCalculo)"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-danger"
                      title="Excluir"
                      (click)="showDeleteConfirmation(item?.id)"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="!grupoItemResponse?.grupoItem?.itens || (grupoItemResponse?.grupoItem?.itens?.length ?? 0) === 0" class="text-center py-5">
          <i class="fas fa-box-open fa-3x text-muted mb-3"></i>
          <h5 class="text-muted mb-0">Nenhum item encontrado</h5>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <!-- Paginação -->
  <div *ngIf="!budgetService.loading && paginacao.totalDeItens > 0" class="card-footer">
    <div class="row">
      <div class="col-sm-12 col-md-5">
        <div class="dataTables_info" role="status" aria-live="polite">
          Mostrando {{ (paginacao.paginaAtual - 1) * paginacao.quantidadePorPagina + 1 }} até
          {{ (paginacao.paginaAtual * paginacao.quantidadePorPagina) > paginacao.totalDeItens ? paginacao.totalDeItens : (paginacao.paginaAtual * paginacao.quantidadePorPagina) }} de
          {{ paginacao.totalDeItens }} registros
        </div>
      </div>
      <div class="col-sm-12 col-md-7">
        <div class="dataTables_paginate paging_simple_numbers">
            <ngb-pagination
              [page]="paginacao.paginaAtual"
              [pageSize]="paginacao.quantidadePorPagina"
              [collectionSize]="paginacao.totalDeItens"
              [maxSize]="5"
              [rotate]="true"
              [boundaryLinks]="true"
              (pageChange)="onPageChange($event)"
              class="pagination-rounded justify-content-end">
            </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<app-moda-editar (confirmEdit)="handleEdit($event)">
</app-moda-editar>